import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { getNestedObject,getRoutePath } from "../../utils/common";
import { sanitizeUrl } from "@braintree/sanitize-url";
import Hamburger from '../../assets/images/hamburger-oxford.svg';
import rightChevron from '../../assets/images/right-chevron-royal.svg';
import Cross from '../../assets/images/cross-royal.svg';

const ProfileLeftMenu = (props) => {
  const { t } = useTranslation();
  const { pageName,isRole,navigate,showMenu } = props;
  const scrollToTop = () => {
    props.rightSection.current.scrollIntoView();
  };

  const changeUrl = () => {
        let url;
        let appAdminEndpoint;
        const locationUrl = window.location.origin;
        if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
          appAdminEndpoint = 'https://dev.account.ct.gov';
        } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
          appAdminEndpoint = 'https://stg.account.ct.gov';
        } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
          appAdminEndpoint = 'https://devc.account.ct.gov';
        } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
          appAdminEndpoint = 'https://psup.account.ct.gov';    
        } else if (locationUrl.indexOf('login.ct.gov') > 0) {
          appAdminEndpoint = 'https://account.ct.gov';
        }
        url = `${appAdminEndpoint}`;
        url = sanitizeUrl(url);
        window.open(url, "_blank");
        scrollToTop();
  };

  const renderActivePageTitle = () => {
    let title = "";
    switch (pageName) {
      case "loginAndSecurity":
        title = t("pages.profile.loginAndSecurity");
        break;
      case "personalInformation":
        title = t("pages.profile.personalInformation");
        break;
      default:
        title = t("pages.profile.preferences");
        break;
    }
    return title;
  };
  const HandleEnterKey = (e) => {
      if(e.keyCode === 13){
        navigate(!showMenu)
      }
  }
  return (
    <div className="profile-menu">
      <h1 className="profile-menu__title">
        <Link
        to={`${getRoutePath}/profile`}
        onClick={() => {
          navigate(false);
          if (pageName !== "") {
            scrollToTop();
          }
        }}
        >
          {t("pages.profile.manageAccount")}
        </Link>
        
      </h1>
      <div
        className={`profile-menu__active ${showMenu ? "active" : ""}`}
        tabIndex={0}
        aria-controls="list"
        aria-haspopup="true"
        onKeyDown={(e) => HandleEnterKey(e)}
        onClick={() => {
          const show = !showMenu;
          navigate(show);
        }}
        // onBlur={(e)=>{
        //   const className = getNestedObject(e, [
        //     "relatedTarget",
        //     "className"
        //   ]);
        //   if (className===null || (className && !className.includes("option-item"))) {
        //     setShowMenu(false);
        //   }
        // }}
      >
        <div className={`oxford-background ${showMenu ? 'active':''}`}></div>
        <img src={Hamburger} alt="hamburger icon" />
      </div>
      <div className={`profile-menu__options ${showMenu? 'active':''}`}>
          <div className="closeMenu" onClick={()=>{
            navigate(false);
          }}>
            <img src={Cross} alt="cross icon" role="presentation"></img>
          </div>
          <ul
          id="list"
          role="menu"
            className="profile-menu__options-list list-unstyled"
          >
            <li role="presentation">
              <Link
                role="menuitem"
                to={`${getRoutePath}/profile`}
                className={`manage option-item ${pageName === "" ? "active" : ""}`}
                onClick={() => {
                  navigate(false);
                  if (pageName !== "") {
                    scrollToTop();
                  }
                }}
              >
                {t("pages.profile.manageAccount")}
                <img src={rightChevron} alt="right chevron" role="presentation" />
              </Link>
            </li>
            <li role="presentation">
              <Link
                role="menuitem"
                to={`${getRoutePath}/profile/preferences`}
                className={`preferences option-item ${pageName === "preferences" ? "active" : ""}`}
                onClick={() => {
                  navigate(false);
                  if (pageName !== "preferences") {
                    scrollToTop();
                  }
                }}
              >
                {t("pages.profile.preferences")}
                <img src={rightChevron} alt="right chevron" role="presentation" />
              </Link>
            </li>
            <li role="presentation">
              <Link
              role="menuitem"
                className={`profile option-item ${
                  pageName === "personalInformation" ? "active" : ""
                }`}
                to={`${getRoutePath}/profile/personalInformation`}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(false);
                  console.log('this is working')
                  if (pageName !== "personalInformation") {
                    scrollToTop();
                  }
                }}
              >
                {t("pages.profile.personalInformation")}
                <img src={rightChevron} alt="right chevron" role="presentation" />
              </Link>
            </li>
            <li role="presentation">
              <Link
              role="menuitem"
                className={`login-and-sercurity option-item ${
                  pageName === "loginAndSecurity" ? "active" : ""
                }`}
                to={`${getRoutePath}/profile/loginAndSecurity`}
                onClick={() => {
                  navigate(false);
                }}
              >
                {t("pages.profile.loginAndSecurity")}
                <img src={rightChevron} alt="right chevron" role="presentation" />
              </Link>
            </li>
            {isRole && (
              <li>
              <Link
                className={`admin`}
              onClick= {() => {
                  changeUrl();
              
                }}
              >
                {t("pages.profile.admin")}
              </Link>
            </li>
          )}
          </ul>
        </div>
    </div>
  );
};

ProfileLeftMenu.propTypes = {
  pageName: PropTypes.string.isRequired,
  rightSection: PropTypes.object.isRequired
};
export default ProfileLeftMenu;
